import React from "react"
import * as styles from "./DropDown.module.css"

type DropDownProps = {
  children: React.ReactElement
  title: React.ReactElement
}

const DropDown = ({ children, title }: DropDownProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}> {title}</div>

      <div className={styles.children}>{children}</div>
    </div>
  )
}

export default DropDown
